import { useEffect } from 'react';
export const useClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
        };
    }, [ref, handler]);
};
// Hook to show scrollbar only when scrolling
export const useScrollbarVisibility = () => {
    useEffect(() => {
        let scrollTimeout;
        const handleScroll = (e) => {
            e.target.classList.add('scrolling');
            // Clear existing timeout
            clearTimeout(scrollTimeout);
            // Remove scrolling class after scrolling stops (300ms delay)
            scrollTimeout = setTimeout(() => {
                e.target.classList.remove('scrolling');
            }, 300);
        };
        // Add scroll listeners to all scrollable elements
        const scrollableElements = document.querySelectorAll('[style*="overflow"], .nav-container, .app-container');
        // Listen to scroll events on scrollable containers
        scrollableElements.forEach((element) => {
            element.addEventListener('scroll', handleScroll, { passive: true });
        });
        return () => {
            clearTimeout(scrollTimeout);
            window.removeEventListener('scroll', handleScroll);
            scrollableElements.forEach((element) => {
                element.removeEventListener('scroll', handleScroll);
            });
            // Clean up class on unmount
            document.body.classList.remove('scrolling');
        };
    }, []);
};
